import { Injectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';

export interface MealMenuItem {
  id: string;
  day: string;
  dayOrder: number;
  hotMeal?: string | null;
  coldMeal?: string | null;
  vegHotMeal?: string | null;
  vegColdMeal?: string | null;
  nonVegHotMeal?: string | null;
  nonVegColdMeal?: string | null;
  specialEvents?: string | null;
}

export interface MealMenuListResponse {
  statusCode: number;
  message: string;
  total: number;
  menus: MealMenuItem[];
  mealDietPreference?: string | null;
}

export interface MealMenuBulkUpdateItem {
  day: string;
  hotMeal?: string;
  coldMeal?: string;
  vegHotMeal?: string;
  vegColdMeal?: string;
  nonVegHotMeal?: string;
  nonVegColdMeal?: string;
  specialEvents?: string;
}

export interface MealMenuBulkRowError {
  row: number;
  day?: string | null;
  message: string;
}

export interface MealMenuBulkUpdateResponse {
  statusCode: number;
  message: string;
  total: number;
  updated: number;
  failed: number;
  menus: MealMenuItem[];
  errors: MealMenuBulkRowError[];
}

export interface MealMenuUpdateRequest {
  hotMeal?: string;
  coldMeal?: string;
  vegHotMeal?: string;
  vegColdMeal?: string;
  nonVegHotMeal?: string;
  nonVegColdMeal?: string;
  specialEvents?: string;
}

export interface MealMenuResponse {
  statusCode: number;
  message: string;
  menu: MealMenuItem;
}

@Injectable({
  providedIn: 'root',
})
export class MealMenuAdminService {
  private readonly apiService = inject(ApiService);

  listMenus(userId?: number | null): Observable<MealMenuListResponse> {
    let params: HttpParams | undefined;
    if (userId != null && Number.isFinite(userId) && userId > 0) {
      params = new HttpParams().set('userid', String(userId));
    }
    return this.apiService.get<MealMenuListResponse>(API_ENDPOINTS.ADMIN.MEAL_MENUS.LIST, params);
  }

  updateMenu(dayName: string, request: MealMenuUpdateRequest): Observable<MealMenuResponse> {
    return this.apiService.put<MealMenuResponse>(
      API_ENDPOINTS.ADMIN.MEAL_MENUS.UPDATE(dayName),
      request,
    );
  }

  bulkUpdateMenus(menus: MealMenuBulkUpdateItem[]): Observable<MealMenuBulkUpdateResponse> {
    return this.apiService.post<MealMenuBulkUpdateResponse>(API_ENDPOINTS.ADMIN.MEAL_MENUS.BULK, {
      menus,
    });
  }
}
